import { productApiUrl } from "API/urls/product.api";
import { axiosInstance } from "configs/axios";

export const fetchProductFromIdApi = async (productId) => {
  try {
    const response = await axiosInstance.get(
      productApiUrl.getProductById + "/" + productId
    );
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
